<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Server-Cache löschen</h3>
        </div>
      </div>
      <div class="card-body">
        <button class="submit-btn-fill-color" style="color: #fff; width: 20%;" @click="confirmDialog=!confirmDialog">Server-Cache löschen</button>
      </div>
    </div>

    <v-dialog v-model="confirmDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen sie wirklich den Server-Cache löschen? Dieser Vorgang kann einige Minuten dauern.</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            ABBRECHEN
          </v-btn>
          <v-btn
            type="submit"
            @click="ClearCache()"
            ref="kt_form_submit_btn"
            class="yes-button"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="products" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import HtmlClass from "@/core/services/htmlclass.service";
import Notifications from "vue-notification";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);

export default {
  name: "Products",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      //HtmlClass.init(this.layoutConfig());
      //this.userId = localStorage.getItem("local_products_user_access_id");
    }
  },
  data() {
    return {
      loading_products: true,
      confirmDialog: false,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null
    };
  },
  methods: {
    hideModal() {
      this.yesActionLoading = false;
      this.confirmDialog = false;
    },
    ClearCache() {
      this.yesActionLoading = true;
      adminAPI
        .cacheClear()
        .then((response) => {
          this.yesActionLoading = false;
            if (response['status'] == 'success') {
              this.$notify({
              group: "products",
              type: "success",
              position: "bottom right",
              text: 'Cache wurde erfolgreich gelöscht',
              duration: 3000,
            });
            this.hideModal()
          } else {
            this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: 'Error',
            duration: 3000,
          });
           this.hideModal()
        }
        })
        .catch((err) => {
          this.yesActionLoading = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_products = false;
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
           this.hideModal()
        });
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
